import BusRatesTable from './BusRatesTable';
import './smallkey.css';
import { Helmet } from 'react-helmet';
import FaqSection from './FAQKeyword';
import FleetHighway from './FleetHighway';
import ContactShowcase from './phoneToWhatsApp';
import TestimonialSectionKeyword from './TestimonialSectionKeyword';

function Punetodapoliinnova() {



const cardData = {
keyword: "Pune to Dapoli Innova Crysta Cab Service",
headingDescription: "Pune to Dapoli Innova Crysta Cab Service is a comfortable private travel option for families, groups, tourists, and weekend travelers heading toward the Konkan coast. The spacious 7-seater Innova Crysta provides air-conditioned seating, practical luggage space, and driver-assisted transportation for one-way journeys, round trips, beach holidays, sightseeing plans, family tours, and longer outstation travel. Passengers can travel conveniently from Pune to Dapoli and explore nearby coastal attractions, beaches, viewpoints, temples, and other destinations according to their planned itinerary.",
topPlaces: [
{
title: "Dapoli",
description: "Dapoli is a popular Konkan destination known for its pleasant coastal surroundings, beaches, temples, and relaxed holiday atmosphere. An Innova Crysta cab from Pune provides spacious private transportation for families and groups carrying luggage and planning a comfortable trip to Dapoli."
},
{
title: "Karde Beach",
description: "Karde Beach is a scenic coastal attraction near Dapoli, appreciated for its broad shoreline and peaceful surroundings. Travelers visiting with family or friends can use a spacious Innova Crysta to reach the beach comfortably while carrying luggage and other travel essentials."
},
{
title: "Ladghar Beach",
description: "Ladghar Beach is a well-known coastal destination in the Dapoli region, making it suitable for leisure trips and weekend holidays. A private Innova Crysta allows families and groups to travel together from Dapoli toward the beach with comfortable seating and convenient luggage capacity."
},
{
title: "Murud Beach",
description: "Murud Beach near Dapoli offers a pleasant coastal setting for travelers looking for a relaxing beach outing. An Innova Crysta tourist cab provides a convenient option for families and groups who want private transportation while exploring the beach and nearby attractions."
},
{
title: "Suvarnadurg Fort",
description: "Suvarnadurg Fort is a historic coastal fortification associated with the Konkan region and maritime history. Travelers visiting the Dapoli area can include this destination in a sightseeing itinerary, with an Innova Crysta offering comfortable road transportation for the group."
},
{
title: "Harnai",
description: "Harnai is a coastal village near Dapoli known for its fishing harbor, beaches, and access to nearby attractions. A private Innova Crysta is useful for families and tourists who want to combine Harnai with other Dapoli sightseeing locations during their coastal journey."
},
{
title: "Panhalekaji Caves",
description: "Panhalekaji Caves are an important historical and archaeological attraction in the Dapoli region. Travelers interested in exploring local heritage can include the caves in a private sightseeing itinerary, with an Innova Crysta providing comfortable transportation for families and groups."
},
{
title: "Keshavraj Temple",
description: "Keshavraj Temple is a peaceful religious attraction surrounded by greenery in the Dapoli region. A private tourist cab makes it easier for families and groups to include the temple in a broader Dapoli sightseeing route along with nearby beaches and natural attractions."
},
{
title: "Unhavare Hot Water Springs",
description: "Unhavare Hot Water Springs are a notable natural attraction in the Dapoli area and can be included in a relaxed sightseeing itinerary. An Innova Crysta provides a practical travel option for groups who want to visit the springs along with other regional destinations."
},
{
title: "Dabhol",
description: "Dabhol is a historic coastal settlement in the Konkan region with connections to local maritime and cultural history. Travelers can include Dabhol in a longer Dapoli-area tour, using a spacious Innova Crysta for convenient private transportation between different stops."
}
],
services: [
{
name: "Pune to Dapoli Innova Crysta Taxi",
description: "Pune to Dapoli Innova Crysta Taxi provides private driver-assisted transportation for families, groups, and tourists traveling toward the Konkan coast. The spacious vehicle offers comfortable seating and useful luggage capacity for a relaxed intercity journey."
},
{
name: "Pune Dapoli Innova Crysta Cab Booking",
description: "Pune Dapoli Innova Crysta Cab Booking allows travelers to arrange a spacious 7-seater vehicle according to their planned Dapoli itinerary. It is suitable for family holidays, weekend breaks, beach trips, sightseeing programs, and group travel from Pune."
},
{
name: "Pune to Dapoli Innova Crysta Rental",
description: "Pune to Dapoli Innova Crysta Rental provides a private vehicle for travelers heading from Pune to Dapoli. The service is suitable for one-way travel, return journeys, family vacations, weekend trips, and sightseeing plans involving multiple coastal destinations."
},
{
name: "Pune to Dapoli Innova Crysta on Rent",
description: "Pune to Dapoli Innova Crysta on Rent offers a spacious travel option for families and groups planning a private road journey. The air-conditioned cabin and luggage space make it practical for beach holidays, family tours, weekend travel, and longer Konkan itineraries."
},
{
name: "Pune to Dapoli Innova Crysta Hire",
description: "Pune to Dapoli Innova Crysta Hire provides driver-assisted transportation for travelers who prefer a private vehicle for their coastal journey. It can be used for family trips, group travel, sightseeing, beach visits, religious tours, and planned weekend getaways."
},
{
name: "Pune Dapoli AC Innova Crysta Cab",
description: "Pune Dapoli AC Innova Crysta Cab provides an air-conditioned cabin for a comfortable journey from Pune toward Dapoli. The spacious interior is useful for families, senior travelers, groups, and tourists who want a relaxed vehicle for the longer coastal route."
},
{
name: "Pune Dapoli Luxury Innova Crysta Cab",
description: "Pune Dapoli Luxury Innova Crysta Cab offers a spacious and refined private travel environment for passengers planning a comfortable coastal holiday. It is suitable for families, corporate groups, special trips, and travelers who prefer a larger vehicle with comfortable seating."
},
{
name: "Pune to Dapoli 7 Seater Innova Crysta",
description: "Pune to Dapoli 7 Seater Innova Crysta is suitable for families and small groups who want to travel together in one vehicle. The spacious cabin reduces the need for multiple cars while providing practical room for passengers and their holiday luggage."
},
{
name: "Pune Dapoli One Way Innova Crysta Cab",
description: "Pune Dapoli One Way Innova Crysta Cab is useful for travelers who need private transportation from Pune to Dapoli without an immediate return journey. It can suit family visits, holiday travel, relocation requirements, and one-direction coastal trips."
},
{
name: "Pune Dapoli Round Trip Innova Crysta Cab",
description: "Pune Dapoli Round Trip Innova Crysta Cab provides transportation for both the onward and return portions of a planned trip. Families and groups can use the same private vehicle for beach holidays, sightseeing tours, weekend breaks, and multi-day Dapoli itineraries."
},
{
name: "Pune to Dapoli Outstation Innova Crysta",
description: "Pune to Dapoli Outstation Innova Crysta provides a spacious private vehicle for the intercity journey from Pune to the Konkan region. It is suitable for families, tourists, and groups who require comfortable seating, luggage space, and driver-assisted travel."
},
{
name: "Pune Dapoli Family Trip Cab",
description: "Pune Dapoli Family Trip Cab provides convenient private transportation for families planning a coastal holiday. The Innova Crysta offers spacious seating and luggage capacity for parents, children, and other family members traveling together on the Pune-Dapoli route."
},
{
name: "Pune Dapoli Group Travel Cab",
description: "Pune Dapoli Group Travel Cab is suitable for friends, relatives, colleagues, and small groups traveling together. A 7-seater Innova Crysta allows passengers to coordinate their journey in one private vehicle while carrying luggage comfortably for the Dapoli trip."
},
{
name: "Affordable Pune Dapoli Innova Crysta Cab",
description: "Affordable Pune Dapoli Innova Crysta Cab provides a practical travel option for passengers who need spacious seating and luggage capacity for a coastal journey. It can be used for family holidays, weekend trips, group travel, sightseeing, and beach visits."
},
{
name: "Pune Dapoli Weekend Trip Cab",
description: "Pune Dapoli Weekend Trip Cab is convenient for travelers planning a short coastal break from Pune. The Innova Crysta provides comfortable seating for families and friends, with sufficient luggage space for a weekend itinerary covering beaches and nearby attractions."
},
{
name: "Pune Dapoli Beach Trip Innova Crysta",
description: "Pune Dapoli Beach Trip Innova Crysta is suitable for travelers planning visits to Dapoli's coastal attractions and nearby beaches. The private vehicle provides comfortable transportation for families and groups carrying beach essentials, luggage, and personal belongings."
},
{
name: "Pune Dapoli Sightseeing Cab",
description: "Pune Dapoli Sightseeing Cab allows travelers to plan private transportation around multiple attractions in the Dapoli region. Families and groups can visit beaches, temples, historical locations, natural attractions, and nearby coastal destinations in a spacious Innova Crysta."
},
{
name: "Pune Dapoli Tourist Cab",
description: "Pune Dapoli Tourist Cab provides private transportation for visitors exploring the Konkan coast. The spacious Innova Crysta is useful for family holidays, group tours, beach trips, heritage visits, religious travel, and sightseeing itineraries with several destinations."
},
{
name: "Pune Dapoli Innova Crysta Taxi Service",
description: "Pune Dapoli Innova Crysta Taxi Service provides driver-assisted private transportation between Pune and Dapoli. It is suitable for one-way journeys, round trips, family vacations, weekend holidays, tourist travel, and group transportation requiring a spacious vehicle."
},
{
name: "Pune Dapoli Innova Crysta Cab Near Me",
description: "Pune Dapoli Innova Crysta Cab Near Me is useful for travelers searching for an outstation vehicle close to their Pune pickup location. The spacious Innova Crysta can accommodate families and groups with luggage for their planned Dapoli journey."
},
{
name: "Pune Dapoli Private Cab",
description: "Pune Dapoli Private Cab provides exclusive transportation for individuals, families, and groups traveling from Pune to Dapoli. Passengers can travel together without sharing the vehicle with unrelated travelers, making it convenient for personalized coastal trips."
},
{
name: "Pune Dapoli Innova Crysta Cab Hire",
description: "Pune Dapoli Innova Crysta Cab Hire offers a spacious private vehicle for travelers planning a Dapoli journey. It can support family tours, beach holidays, sightseeing programs, group trips, weekend travel, and return journeys with driver assistance."
},
{
name: "Pune Dapoli Rental Car with Driver",
description: "Pune Dapoli Rental Car with Driver provides chauffeur-assisted transportation for passengers who want to travel privately from Pune to Dapoli. It is suitable for families, tourists, groups, and travelers planning sightseeing stops along the Konkan route."
},
{
name: "Pune Dapoli Family Tour Cab",
description: "Pune Dapoli Family Tour Cab is designed for families planning a complete coastal holiday with multiple sightseeing stops. The spacious Innova Crysta provides comfortable seating and luggage capacity while allowing family members to travel together throughout the itinerary."
},
{
name: "Pune Dapoli Outstation Taxi",
description: "Pune Dapoli Outstation Taxi provides private driver-assisted transportation for travelers making the journey from Pune to Dapoli. It is suitable for families, groups, tourists, weekend travelers, and passengers planning one-way or round-trip coastal travel."
}
],
tableData: [
["Pune to Dapoli Innova Crysta Taxi"],
["Pune Dapoli Innova Crysta Cab Booking"],
["Pune to Dapoli Innova Crysta Rental"],
["Pune to Dapoli Innova Crysta on Rent"],
["Pune to Dapoli Innova Crysta Hire"],
["Pune Dapoli AC Innova Crysta Cab"],
["Pune Dapoli Luxury Innova Crysta Cab"],
["Pune to Dapoli 7 Seater Innova Crysta"],
["Pune Dapoli One Way Innova Crysta Cab"],
["Pune Dapoli Round Trip Innova Crysta Cab"],
["Pune to Dapoli Outstation Innova Crysta"],
["Pune Dapoli Family Trip Cab"],
["Pune Dapoli Group Travel Cab"],
["Affordable Pune Dapoli Innova Crysta Cab"],
["Pune Dapoli Weekend Trip Cab"],
["Pune Dapoli Beach Trip Innova Crysta"],
["Pune Dapoli Sightseeing Cab"],
["Pune Dapoli Tourist Cab"],
["Pune Dapoli Innova Crysta Taxi Service"],
["Pune Dapoli Innova Crysta Cab Near Me"],
["Pune Dapoli Private Cab"],
["Pune Dapoli Innova Crysta Cab Hire"],
["Pune Dapoli Rental Car with Driver"],
["Pune Dapoli Family Tour Cab"],
["Pune Dapoli Outstation Taxi"]
],
whychoose: [
{
WhyChooseheading: "Comfortable 7-Seater Cabin",
WhyChoosedescription: "The Innova Crysta offers practical seating for families and small groups traveling from Pune to Dapoli. Its spacious interior allows passengers to travel together comfortably while keeping their holiday luggage organized throughout the journey."
},
{
WhyChooseheading: "Ideal for Konkan Holidays",
WhyChoosedescription: "Dapoli trips often include beaches, temples, historical attractions, and natural sightseeing locations. A private Innova Crysta makes it easier for travelers to plan these stops around their itinerary without depending on shared transportation."
},
{
WhyChooseheading: "Private Door-to-Door Travel",
WhyChoosedescription: "Private cab transportation allows passengers to begin the journey from their preferred Pune pickup point and continue directly toward Dapoli. This can be particularly convenient for families carrying luggage or groups traveling with multiple passengers."
},
{
WhyChooseheading: "Suitable for Beach Trips",
WhyChoosedescription: "Families and friends visiting Karde, Ladghar, Murud, and other coastal attractions can benefit from the vehicle's spacious seating and luggage area. This makes it practical for carrying travel bags and beach-related essentials during the trip."
},
{
WhyChooseheading: "One-Way and Round-Trip Flexibility",
WhyChoosedescription: "Different travelers have different itinerary requirements, so transportation can be planned around either an onward journey or a return trip. This works well for weekend breaks, family holidays, sightseeing tours, and longer Dapoli stays."
},
{
WhyChooseheading: "Air-Conditioned Comfort",
WhyChoosedescription: "The air-conditioned cabin provides a comfortable environment during the road journey from Pune toward the Konkan coast. It is useful for families, children, senior passengers, and groups looking for a relaxed private travel experience."
},
{
WhyChooseheading: "Convenient for Group Travel",
WhyChoosedescription: "A 7-seater Innova Crysta can bring a small group together in one vehicle rather than requiring separate cars. This simplifies coordination for family tours, friend groups, weekend trips, sightseeing programs, and beach holidays."
},
{
WhyChooseheading: "Driver-Assisted Outstation Journey",
WhyChoosedescription: "With a driver handling the route, passengers can focus on their companions, luggage, sightseeing plans, and holiday activities. Driver-assisted travel is especially useful when the itinerary includes several destinations around Dapoli and the wider Konkan region."
}
]
};


















const faqData = [
{
question: "Can I book an Innova Crysta from Pune to Dapoli?",
answer: "An Innova Crysta can be arranged for a Pune to Dapoli journey when families, couples, or groups prefer to travel together in a spacious vehicle. Citysky Cabs can plan the cab according to your pickup location, travel date, passenger count, luggage, and preferred departure schedule."
},
{
question: "Is an Innova Crysta suitable for travelling from Pune to Dapoli?",
answer: "The Innova Crysta can be a practical option for the Pune to Dapoli route, especially for passengers planning a longer road journey with luggage. Travelling together in one vehicle also makes it easier to coordinate stops, departure timings, and sightseeing plans along the trip."
},
{
question: "Can I hire an Innova Crysta for a Dapoli weekend trip?",
answer: "A weekend trip from Pune to Dapoli can be planned with an Innova Crysta for families, friends, and small groups. The itinerary may include an overnight stay, local sightseeing, beach visits, and a return journey based on the group's preferred travel dates and schedule."
},
{
question: "Can families book a Pune to Dapoli Innova Crysta cab?",
answer: "Families can choose an Innova Crysta when travelling to Dapoli for a holiday, family outing, or coastal getaway. One dedicated vehicle allows family members to remain together during the journey while providing space for luggage and planned travel breaks."
},
{
question: "Can I book a one-way Innova Crysta from Pune to Dapoli?",
answer: "One-way cab arrangements can be discussed for passengers who need transportation from Pune to Dapoli without requiring the same vehicle for their return journey. Share the pickup area, destination, travel date, passenger count, and preferred departure time during the booking enquiry."
},
{
question: "Is round-trip Innova Crysta cab service available for Dapoli?",
answer: "A round-trip Innova Crysta can be planned for travellers who want to travel from Pune to Dapoli, spend time at the destination, and return to Pune. This arrangement can work well for weekend holidays, family trips, beach visits, and multi-day sightseeing plans."
},
{
question: "Can I carry luggage in an Innova Crysta on the Pune to Dapoli route?",
answer: "Travellers can share their approximate luggage requirements while enquiring about the cab. This is particularly useful for families and groups staying in Dapoli for several days, as suitcases, travel bags, and other personal belongings may need to be considered when planning the vehicle arrangement."
},
{
question: "Can I use an Innova Crysta for Dapoli sightseeing?",
answer: "An Innova Crysta can be used as part of a Dapoli sightseeing itinerary when passengers want to visit multiple local attractions during their stay. The travel plan can be discussed with Citysky Cabs based on the number of passengers, sightseeing locations, available time, and return requirements."
},
{
question: "Can I book an Innova Crysta for a group trip from Pune to Dapoli?",
answer: "Small groups can arrange an Innova Crysta for a Dapoli holiday when travelling together is more convenient than using separate vehicles. The booking can be planned around the group's passenger count, luggage, departure timing, accommodation schedule, and sightseeing requirements."
},
{
question: "How can I book Pune to Dapoli Innova Crysta Cab Service with Citysky Cabs?",
answer: "To arrange the cab, provide your Pune pickup location, Dapoli destination, travel date, number of passengers, luggage details, preferred departure time, and whether you need one-way or return transportation. Citysky Cabs can coordinate the Innova Crysta service around your complete travel itinerary."
}
];

const testimonials = [
{
id: 1,
name: "Mr. Vinay Sawant",
feedback:
"We planned a family weekend in Dapoli from Pune and needed enough space for everyone along with our bags. The Innova Crysta was a good fit for our travel plan, especially because we wanted to visit a few places during the trip. Citysky Cabs handled the booking details according to our schedule and made the transportation easy to organize.",
rating: 5
},
{
id: 2,
name: "Miss. Manasi Kulkarni",
feedback:
"I arranged an Innova Crysta for a Dapoli trip with friends and we wanted to travel together from Pune. We had luggage for an overnight stay and planned some local sightseeing after reaching there. The booking process with Citysky Cabs was straightforward, and having one cab for the journey made the trip more convenient.",
rating: 5
}
];




























    const Images = [

    { place: "/images/keyword/1.jpg", text: "Innova Crysta Cab in Pune", link: "innova-crysta-cab-in-pune" },

    { place: "/images/keyword/2.jpg", text: "Innova Crysta On Rent in Pune", link: "innova-crysta-on-rent-in-pune" },

    { place: "/images/keyword/3.jpg", text: "Innova Crysta Cabs / Taxi Booking in Pune", link: "innova-crysta-cabs-taxi-booking-in-pune" },

    { place: "/images/keyword/4.jpg", text: "Pune to Mahabaleshwar Innova Crysta Cab", link: "pune-to-mahabaleshwar-innova-crysta-cab" },

    { place: "/images/keyword/5.jpg", text: "Book Innova Crysta for Outstation From Pune", link: "book-innova-crysta-for-outstation-from-pune" },

    { place: "/images/keyword/6.jpg", text: "Innova Crysta Cabs for Pune Airport", link: "innova-crysta-cabs-for-pune-airport" },

    { place: "/images/keyword/7.jpg", text: "Pune to Mumbai Airport Innova Crysta", link: "pune-to-mumbai-airport-innova-crysta" },

    { place: "/images/keyword/8.jpg", text: "Innova Crysta Cab for Corporate Office", link: "innova-crysta-cab-for-corporate-office" },

    { place: "/images/keyword/9.jpg", text: "Mumbai Airport to Pune Innova Crysta Cabs", link: "mumbai-airport-to-pune-innova-crysta-cabs" },

    { place: "/images/keyword/10.jpg", text: "Pune to Shirdi Innova Crysta", link: "pune-to-shirdi-innova-crysta" },

    { place: "/images/keyword/11.jpg", text: "Pune Aurangabad Innova Crysta Cab Service", link: "pune-aurangabad-innova-crysta-cab-service" },

    { place: "/images/keyword/12.jpg", text: "Pune to Goa Innova Crysta Cab", link: "pune-to-goa-innova-crysta-cab" },

    { place: "/images/keyword/13.jpg", text: "Pune to Bangalore Innova Crysta Cab", link: "pune-to-bangalore-innova-crysta-cab" },

    { place: "/images/keyword/14.jpg", text: "Pune to Hyderabad Innova Crysta Rental Cab", link: "pune-to-hyderabad-innova-crysta-rental-cab" },

    { place: "/images/keyword/15.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-2" },

    { place: "/images/keyword/16.jpg", text: "Pune to Lavasa Innova Crysta Cab Booking", link: "pune-to-lavasa-innova-crysta-cab-booking" },

    { place: "/images/keyword/17.jpg", text: "Pune Darshan Innova Crysta Cabs", link: "pune-darshan-innova-crysta-cabs" },

    { place: "/images/keyword/18.jpg", text: "Innova Crysta Cabs in Pune", link: "innova-crysta-cabs-in-pune" },

    { place: "/images/keyword/19.jpg", text: "Innova Car Rental In Pune", link: "innova-car-rental-in-pune" },

    { place: "/images/keyword/20.jpg", text: "Innova Taxi Service in Pune", link: "innova-taxi-service-in-pune" },

    { place: "/images/keyword/21.jpg", text: "Book Innova for Outstation Pune", link: "book-innova-for-outstation-pune" },

    { place: "/images/keyword/22.jpg", text: "Innova Crysta On Rent In Pune", link: "innova-crysta-on-rent-in-pune-3" },

    { place: "/images/keyword/23.jpg", text: "Pune to Mahabaleshwar Panchgani Innova Crysta Cabs", link: "pune-to-mahabaleshwar-panchgani-innova-crysta-cabs" },

    { place: "/images/keyword/24.jpg", text: "Pune to Outstation Innova Crysta Booking", link: "pune-to-outstation-innova-crysta-booking" },

    { place: "/images/keyword/25.jpg", text: "Innova Crysta on Rent in Pune", link: "innova-crysta-on-rent-in-pune-4" },


];












const productSchema = {
  "@context": "https://schema.org",
  "@type": "Product",
  "name": "Pune to Dapoli Innova Crysta Cab Service",
  "image": "https://www.cityskycab.in/assets/images/pune-to-dapoli-innova-crysta-cab-service.webp",
  "description": "Pune to Dapoli Innova Crysta Cab Service from Citysky Cabs is a comfortable travel option for families, friends and small groups planning a coastal getaway from Pune to Dapoli. The service includes Pune to Dapoli Innova Crysta Taxi, cab booking, rental, on-rent and hire options, with AC and luxury Innova Crysta vehicles suited to longer highway journeys. Spacious seating and luggage capacity make the vehicle convenient for family trips, weekend vacations and planned coastal travel. Experienced drivers, convenient Pune pickup and flexible one-way or round-trip arrangements help make the journey between Pune and Dapoli more comfortable and convenient.",
  "brand": {
    "@type": "Brand",
    "name": "Citysky Cabs"
  },
  "aggregateRating": {
    "@type": "AggregateRating",
    "bestRating": "5",
    "worstRating": "1",
    "ratingValue": "4.8",
    "ratingCount": "8517"
  },
  "offers": {
    "@type": "Offer",
    "priceCurrency": "INR",
    "price": "Starting From ₹12/Km",
    "availability": "https://schema.org/InStock",
    "url": "https://www.cityskycab.in/pune-to-dapoli-innova-crysta-cab-service"
  }
};





    return (
        <div>


<Helmet>
  <title>
    Pune to Dapoli Innova Crysta Cab Service | Pune Dapoli Luxury Innova Crysta Cab | +91 8554819191
  </title>

  <meta
    name="description"
    content="Travel from Pune to Dapoli in a comfortable Innova Crysta with Citysky Cabs. Choose AC and luxury cab options with spacious seating, experienced drivers and flexible one-way or round-trip travel."
  />

  <meta
    name="keywords"
    content="Pune to Dapoli Innova Crysta Taxi, Pune Dapoli Innova Crysta Cab Booking, Pune to Dapoli Innova Crysta Rental, Pune to Dapoli Innova Crysta on Rent, Pune to Dapoli Innova Crysta Hire, Pune Dapoli AC Innova Crysta Cab, Pune Dapoli Luxury Innova Crysta Cab, Pune to Dapoli Innova Crysta Cab Service, Pune Dapoli Innova Crysta Taxi, Pune Dapoli Innova Crysta Cab, Pune to Dapoli premium cab, Pune to Dapoli AC cab, Pune Dapoli one way Innova Crysta, Pune Dapoli round trip taxi, Innova Crysta for Dapoli trip, Dapoli cab from Pune, Pune to Dapoli 7 seater cab, Pune Dapoli outstation Innova Crysta"
  />

  <script type="application/ld+json">
    {JSON.stringify(productSchema)}
  </script>
</Helmet>


            <div className="sisf-banner sis-br-radius mt-3 position-relative">
                <div className="banner-img">
                    <figure>
                      {/* <img
                            src="/images/page-banner.jpg"
                            alt="Mauliwala Travels Urbania and Mini Bus Rental Pune"
                        /> */}
                    </figure>
                </div>

                <div className="sisf-page-title sisf-m sisf-title--standard sisf-alignment--center">
                    <div className="sisf-m-inner container">
                        <div className="sisf-m-content sisf-content-grid">
                            <h1 className="sisf-m-title text-white sis-text-anime-style-3 entry-title">
                                {cardData.keyword}
                            </h1>
                        </div>
                    </div>
                </div>
            </div>














            <section>
                <div className="container-fluid p-0" >
                    <div className="row container-fluid px-md-2">
                        <div className="col-12 col-md-7 bg-foootr">
                            <img src='/images/keyword/27.jpg' alt='img' className='img-fluid' />
                            <h3 className="py-1"
                                style={{
                                    color: '#183765', // Red color for the title 
                                    textShadow: '5px 5px 10px rgba(255, 255, 255, 0.7)', // Light shadow effect
                                    fontWeight: 'bold'
                                }}


                            >Citysky Cabs: {cardData.keyword} </h3><p className='fw-bold '>{cardData.headingDescription}</p>

                            <div className="topPlaces">

                                <p className="sectionLead">Top Places to visit from {cardData.keyword} </p>
                                {cardData.topPlaces.map((place, index) => (
                                    <article key={index} className="placeCard borderr" tabIndex="0">
                                        <span className="placeBadge">{String(index + 1).padStart(2, "0")}</span>

                                        <div className="placeBody">
                                            <h4 className="placeTitle">{place.title}</h4>
                                            <p className="placeDesc">{place.description}</p>

                                        </div>

                                        <span className="placeArrow" aria-hidden>›</span>
                                    </article>
                                ))}
                            </div>





                            <div className="services-section">
                                {cardData.services.map((service, index) => (
                                    <div className="service-card" key={index}>
                                        <div className="service-content">
                                            <h4>{service.name}</h4>
                                            <span className="line"></span>
                                            <p>{service.description}</p>
                                        </div>

                                        <div className="service-icon">
                                            <i className="fas fa-arrow-right"></i>
                                        </div>
                                    </div>
                                ))}
                            </div>

                            <div className="keyword-grid">
                                {cardData.tableData.flat().map((keyword, index) => (
                                    <div key={index} className="keyword-item">
                                        <span className="keyword-bullet">-</span>
                                        {keyword}
                                    </div>
                                ))}
                            </div>



                            <div id="why-choose-section" className="why-choose-section">

                                <h2 className="section-title text-dark">
                                    Why Choose <span>Citysky Cabs</span>
                                </h2>

                                <div className="bento-grid">
                                    {cardData.whychoose.map((item, index) => (
                                        <div className="bento-card" key={index}>

                                            <div className="bento-number">
                                                {String(index + 1).padStart(2, "0")}
                                            </div>

                                            <h4>{item.WhyChooseheading}</h4>

                                            <p>{item.WhyChoosedescription}</p>

                                        </div>
                                    ))}
                                </div>

                            </div>



                            <div className="row twm-faq-section-1 m-b30">


                                <div className=" col-md-12 wow fadeInDown" data-wow-delay="0.2">
                                    <div className="twm-faq-info-wrap">

                                        <div className="section-head left">
                                            <h2 className="twm-large-title site-text-dark">FAQS {cardData.keyword} For Citysky Cabs</h2>
                                        </div>


                                        <div className="twm-faq-info">
                                            <div className="accordion twm-acdn" id="sf-faq-accordion">

                                                <FaqSection
                                                    title=""
                                                    subtitle=""
                                                    items={faqData}
                                                />

                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>

                            <TestimonialSectionKeyword
                                testimonials={testimonials}
                            />


                            <ContactShowcase keyword={cardData.keyword} />
                        </div>

                        <div className='col-12 col-md-4' >
                            <div className="routeList">
                                {Images.map((e, i) => {
                                    const isExternal = typeof e.link === "string" && /^https?:\/\//i.test(e.link);
                                    const href = isExternal ? e.link : `/${String(e.link || "").replace(/^\/+/, "")}`;

                                    return (
                                        <a
                                            key={e.link || i}
                                            href={href}
                                            className="routeItem"
                                            aria-label={e.text}
                                            {...(isExternal ? { target: "_blank", rel: "noopener noreferrer" } : {})}
                                        >
                                            <div className="routeThumb">
                                                <img src={e.place} alt="" loading="lazy" />
                                            </div>

                                            <div className="routeMeta">
                                                <h6 className="routeTitle">{e.text}</h6>
                                                <span className="routeUnderline" />
                                            </div>

                                            <span className="routeArrow" aria-hidden>›</span>
                                        </a>
                                    );
                                })}
                            </div>




                            <div>
                                <FleetHighway />
                            </div>
                            <div className="pc-contact">
                                <h4 className="pc-title">Contact Information</h4>

                                <div className="pc-grid">
                                    {/* Phones */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fas fa-phone-alt"></i>
                                            <span>Phone Numbers</span>
                                        </header>

                                        <div className="pc-list">
                                            <a href="tel:+918554819191" className="pc-call">+91 8554819191 </a>
                                        </div>

                                        <div className="pc-list">
                                            <a href="tel:+918459883515" className="pc-call">+91 8459883515 </a>
                                        </div>
                                        <div className="pc-cta">
                                            <a
                                                href="https://wa.me/918459883515
"
                                                target="_blank"
                                                rel="noopener noreferrer"
                                                className="pc-whats"
                                            >
                                                <i className="bi bi-whatsapp"></i> WhatsApp
                                            </a>
                                            <a href="tel:+918459883515" className="pc-primary">
                                                Call Now
                                            </a>
                                        </div>
                                    </section>

                                    {/* Email */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-envelope"></i>
                                            <span>Email</span>
                                        </header>

                                        <a href="mailto:booking@cityskycab.in" className="pc-email">
                                            booking@cityskycab.in
                                        </a>
                                    </section>

                                    {/* Address */}
                                    <section className="pc-tile">
                                        <header className="pc-tile-head">
                                            <i className="fa-solid fa-location-dot"></i>
                                            <span>Address</span>
                                        </header>

                                        <address className="pc-address">
                                            <strong>Citysky Cabs</strong><br />

                                            Office No,307,3rd Floor,
                                            52, Sinhgad Rd, Wadgaon Budruk,
                                            Narhe, Pune, Maharashtra,India- 411041.






                                        </address>
                                    </section>
                                </div>
                            </div>


                        </div>
                    </div>
                </div>
            </section>


        </div>
    );
}

export default Punetodapoliinnova;